import React from 'react';
import '../App.css';
import calisthenicsImage from '../assets/calisthenic.jpeg';
import HorizontalSwiper from '../components/HorizontalSwiper';
import ReasonsSection from '../components/ReasonsSection';
import Stripes from '../components/Stripes';
import calisthenicBg from '../assets/calisthenuc.jpeg'
import yogahall from "../assets/yogahall.jpg";
import VerticalSwiper from '../components/VerticalSwiper';
import Footer from '../components/Footer';
import Signup from '../components/Signup';

const Calisthenics = () => {
  return (
    <div className="calisthenics-page">
      {/* Hero Section */}
      <div
        className="calisthenics-banner"
        style={{ backgroundImage: `url(${calisthenicsImage})` }}
      >
        {/* Dark overlay */}
        <div className="banner-overlay"></div>

        <h2>CALISTHENICS</h2>
      </div>

     {/* Content Section */}
      <div className="calisthenics-content">
        <h3>What is Calisthenics?</h3>
        <p>
          Calisthenics is the art of building strength, control, and balance
          using your own bodyweight, no machines, no heavy weights. It’s about
          mastering movements like push-ups, pull-ups, dips, and planks, and
          gradually progressing them to more advanced skills (think muscle-ups,
          handstands, front levers).
        </p>
        <p>
          Because every movement is relative to your body, calisthenics builds
          functional strength, mobility, stability, and coordination, all in one.
        </p>
      </div>
      <HorizontalSwiper/>
      <ReasonsSection/>
      <Stripes/>
{/* new */}
 <div className="who-section">
  <img src={calisthenicBg} alt="Background" className="who-bg" />
  <div className="who-overlay"></div>

  <div className="who-content container text-center">
    <h2 className="coach">WHO THIS IS FOR</h2>

    <p className="calisthenic-p">
      You want to <span className="bold">build strength without bulky gym equipment</span>
    </p>
    <p className="calisthenic-p">
      You’re driven to <span className="bold">learn bodyweight skills</span> (e.g. handstands, muscle-ups)
    </p>
    <p className="calisthenic-p">
      You prefer <span className="bold">minimal, efficient training</span>
    </p>
    <p className="calisthenic-p">
      You want to <span className="bold">improve mobility, control, and body awareness</span>
    </p>
    <p className="calisthenic-p">
      You believe in <span className="bold">long-term, sustainable fitness</span>
    </p>
  </div>
</div>
{/* coaching */}
<div className="coaching-section">
  <img src={yogahall} alt="Background" className="coaching-bg" />
  <div className="coaching-overlay"></div>

  {/* Flex wrapper for content + swiper */}
  <div className="coaching-wrapper">
    {/* LEFT: Coaching Content */}
    <div className="coaching-content">
      <h2 className="coaching-heading">
        HOW MY <br /> CALISTHENICS <br /> COACHING WORKS
      </h2>

      <div className="coaching-steps">
        <div className="coaching-step">
          <div className="icon-box">
            <i className="fa-solid fa-brain"></i>
          </div>
          <p>Baseline Assessment</p>
        </div>

        <div className="coaching-step">
          <div className="icon-box">
            <i className="fa-solid fa-dumbbell"></i>
          </div>
          <p>Personalized plan</p>
        </div>

        <div className="coaching-step">
          <div className="icon-box">
            <i className="fa-solid fa-bullseye"></i>
          </div>
          <p>Technique focus</p>
        </div>

        <div className="coaching-step">
          <div className="icon-box">
            <i className="fa-solid fa-person-running"></i>
          </div>
          <p>Skill training</p>
        </div>

        <div className="coaching-step">
          <div className="icon-box">
            <i className="fa-solid fa-heart-pulse"></i>
          </div>
          <p>Recovery And Mobility</p>
        </div>

        <div className="coaching-step">
          <div className="icon-box">
            <i className="fa-solid fa-arrows-rotate"></i>
          </div>
          <p>Ongoing feedback & adjustments</p>
        </div>
      </div>
    </div>

    {/* RIGHT: Vertical Swiper */}
    <div className="coaching-swiper">
      <VerticalSwiper />
    </div>
  </div>
</div>


<Signup/>
<Footer/>
    </div>
    
  );
};

export default Calisthenics;
